import React, { useMemo } from "react";

const ActScoreField = ({
  name,
  label,
  value = "",
  onChange,
  required = false
}) => {
  const options = useMemo(() => {
    const items = [];
    for (let score = 1; score <= 36; score++) {
      items.push(
        <option key={score} value={score}>
          {score}
        </option>
      );
    }
    return items;
  }, []);

  return (
    <div>
      <label htmlFor={name}>{label}</label>
      <select
        id={name}
        className="field"
        name={name}
        value={value}
        onChange={onChange}
        aria-label="Select your ACT score (1–36)"
        required={required}
      >
        <option value="" disabled>
          Select your ACT score
        </option>
        {options}
      </select>
    </div>
  );
};

export default ActScoreField;
